import { FunctionalComponent, h } from '@stencil/core';
import { FundDataPoints } from '../../../_interfaces/fund-card/fund-data-points';

interface CarbsProps {
	flag: boolean;
	dataPointValues: FundDataPoints;
	Tooltip: string;
}

export const Carbs: FunctionalComponent<CarbsProps> = ({
	flag,
	dataPointValues,
	Tooltip,
}) => {
	if (flag)
		return (
			<div class="ds-data-points">
				{dataPointValues.general ? (
					<div class="ds-left-col">
						<div class="ds-body-s">
							{dataPointValues.label}&nbsp;
							<Tooltip
								content={`${dataPointValues.tooltip.first}<br>${dataPointValues.tooltip.second}<br>${dataPointValues.tooltip.third}`}
							></Tooltip>
						</div>
						<div class="ds-fund-data">{dataPointValues.data}</div>
					</div>
				) : null}

				{dataPointValues.secondaryGeneral ? (
					<div class="ds-right-col">
						<div class="ds-body-s">
							{dataPointValues.secondaryLabel}&nbsp;
							{dataPointValues.secondaryTooltip ? (
								<Tooltip
									content={`${dataPointValues.secondaryTooltip.first}<br>${dataPointValues.secondaryTooltip.second}<br>${dataPointValues.secondaryTooltip.third}`}
								></Tooltip>
							) : null}
						</div>
						<div class="ds-fund-data">{dataPointValues.secondaryData}</div>
					</div>
				) : null}
			</div>
		);
};
